import React, { memo } from 'react';
import BulkPricingMSRP from "./BulkPricingMSRP";
import BulkPricingTiers from "./BulkPricingTiers";

const BulkPricingTable = ({ pricing, graphicType, ...props }) => {
  if (!pricing) return null;
  if(!Object.values(pricing).every(p => !!p && p.length > 0)) return null;

  const hasMSRP = !!Object.values(pricing).find(p => !!p[0].rates.find(r => r.msrp > 0));
  const hasTiers = !!Object.values(pricing).find(p => p.length > 1);
  const useMethodPricing = hasMSRP && !hasTiers;

  return (useMethodPricing) ? (
    <BulkPricingMSRP {...props} {...{pricing}} />
  ) : !!pricing[graphicType] ? (
    <BulkPricingTiers {...props} rates={pricing[graphicType][0]?.rates.filter(r => r.visible)} />
  ) : null;
};

export default memo(BulkPricingTable);
